/**
 * O QUE FALTA RECEBER DE UMA FATURA (10/10/2026).
 *
 * Os cartões "A Vencer" e "Vencidas" somavam `totalValue` das faturas Aberta e Parcial. A Parcial entrava cheia, como
 * se nada tivesse sido pago: na cópia local de 10/10/2026, três parciais vencidas inflavam "Vencidas" em R$ 3.058,40,
 * o que já tinha entrado. O que o cartão de "a receber" mostra é o SALDO: total menos o pago, nunca negativo.
 */
export function saldoEmAberto(inv: { totalValue?: number | string | null; paidValue?: number | string | null }): number {
  const total = parseFloat(String(inv?.totalValue ?? 0)) || 0;
  const pago = parseFloat(String(inv?.paidValue ?? 0)) || 0;
  return Math.max(0, total - pago);
}
